import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import { Deal } from "@/types/data";
import { v4 as uuidv4 } from "uuid";

export const dealService = {
  async getAll(): Promise<Deal[]> {
    const { data } = await axios.get<Deal[]>(ApiRoutes.DEALS);
    // Backend keys by slug; give each row a stable client id for the sortable.
    return (data || []).map((d) => ({ ...d, id: d.slug || d.id || uuidv4() }));
  },

  async create(data: Deal[]) {
    const { data: res } = await axios.post(ApiRoutes.DEALS, data);
    return res;
  },
};
